// SPDX-License-Identifier: AGPL-3.0-or-later

// Generated by tools/room_themes/build_manifest.mjs from validated character part files. Do not edit by hand.

import type {RoomCharacterPartManifest} from '@fluxer/constants/src/RoomOutfit';

export const VOICE_ROOM_CHARACTER_PART_MANIFEST: RoomCharacterPartManifest = {
	default_family: 'ithappy',
	families: {
		ithappy: {
			base: 'taban-ithappy.fe2dbb217bb8.mglb',
			bytes: 201704,
			clips: 'klip-ithappy.4093b30f57f7.mglb',
			regions: ['head', 'torso', 'upper_arms', 'lower_arms', 'hands', 'hips', 'thighs', 'shins', 'feet'],
			default_preset: 'ithp-gunluk',
		},
	},
	parts: {
		'ithp-accessory-bandage-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-bandage-001.431ecc419528.mglb',
			bytes: 14728,
			tri: 232,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-bandage-001.3c52a92edb4b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-beard-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-beard-001.cc8d1a324664.mglb',
			bytes: 9452,
			tri: 234,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-beard-001.d939e9152a65.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-beard-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-beard-002.aa29da31b0a9.mglb',
			bytes: 11688,
			tri: 286,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-beard-002.3f9629c3bcd6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-beard-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-beard-003.3ff80de0612c.mglb',
			bytes: 12464,
			tri: 320,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-beard-003.963956a8396f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-clown-nose-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-clown-nose-001.2ca28019efca.mglb',
			bytes: 7380,
			tri: 192,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-clown-nose-001.7f121b40e4f0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-costume-11-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-costume-11-003.8930d5ee2554.mglb',
			bytes: 24152,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-costume-11-003.7a52b5839948.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-costume-14-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-costume-14-003.0f2a3f01ad3a.mglb',
			bytes: 12200,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-costume-14-003.2872d3080494.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-costume-7-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-costume-7-003.b8a7b1cd2737.mglb',
			bytes: 12008,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-costume-7-003.573194f73700.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-costume-8-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-costume-8-003.06cf285400f5.mglb',
			bytes: 16608,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-costume-8-003.8fff952fe1a2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-costume-9-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-costume-9-002.432dd7cbc995.mglb',
			bytes: 16856,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-costume-9-002.08556b4b9211.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-earrings-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-earrings-001.dfd7c95a37c0.mglb',
			bytes: 7764,
			tri: 160,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-earrings-001.7bdbc185f60e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-001.66f2a0ffa73a.mglb',
			bytes: 14140,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-001.a587b7b21ff2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-002.b007ce03d99a.mglb',
			bytes: 14140,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-002.7e428539ae95.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-003.5099280e23fa.mglb',
			bytes: 14140,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-003.ff5dd5c64b2c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-004': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-004.61de15b49915.mglb',
			bytes: 17164,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-004.f2e644df4c58.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-005': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-005.21ba15fde19d.mglb',
			bytes: 17164,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-005.3d5f2bc3afb7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-006': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-006.2230f65b6809.mglb',
			bytes: 17164,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-006.1d4469cba762.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-007': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-007.11d21a3356d7.mglb',
			bytes: 17164,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-007.489a30ae7bb5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-008': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-008.97b7143b8814.mglb',
			bytes: 13516,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-008.2865011c73fe.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-009': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-009.fb11efc3fc03.mglb',
			bytes: 13324,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-009.48ea1e2e21f8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-010': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-010.049ff7f60435.mglb',
			bytes: 13324,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-010.7376ac97000b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-011': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-011.e6f4b31a0931.mglb',
			bytes: 16644,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-011.4118e8553783.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-012': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-012.a279bb5926cb.mglb',
			bytes: 16644,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-012.95e3f96754f1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-013': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-013.4d638033ab48.mglb',
			bytes: 16644,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-013.e4c82c432ede.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-014': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-014.3335256896eb.mglb',
			bytes: 16752,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-014.04184d753fa3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-015': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-015.32bd5b42b4ca.mglb',
			bytes: 16288,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-015.1bfa1a6f7738.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-016': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-016.522692a9a239.mglb',
			bytes: 16288,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-016.4e7a913b5408.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-017': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-017.f0974cf7af82.mglb',
			bytes: 16288,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-017.1b3e99f8e665.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-018': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-018.e10a807000e5.mglb',
			bytes: 14140,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-018.b1adc915efe9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-019': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-019.ec4de4123f32.mglb',
			bytes: 21440,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-019.6d854b6991fc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-020': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-020.5e60a0bac0ce.mglb',
			bytes: 19092,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-020.bc5e3fec7a50.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-021': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-021.26885b93cf72.mglb',
			bytes: 15932,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-021.b2facf831035.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-022': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-022.7f311de71b14.mglb',
			bytes: 15932,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-022.c4eee94510d2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-gloves-023': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-gloves-023.7bc8c2c1b956.mglb',
			bytes: 15932,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-gloves-023.d4c600ba5971.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-headphones-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-headphones-002.8ea17e067094.mglb',
			bytes: 10556,
			tri: 256,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-headphones-002.57d50d031b3f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mask-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mask-001.bc8cb77899a4.mglb',
			bytes: 13352,
			tri: 188,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mask-001.ea36a0d6805e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mask-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mask-002.17e62847e9c4.mglb',
			bytes: 7960,
			tri: 130,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mask-002.950c88f0e983.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-001.0c9f2e5a35bb.mglb',
			bytes: 4204,
			tri: 72,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-001.7d9b026dc01d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-002': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-002.92895885ff03.mglb',
			bytes: 6484,
			tri: 140,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-002.4310b0296be4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-003': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-003.f1abfeec0feb.mglb',
			bytes: 10744,
			tri: 304,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-003.ab6f8770da6b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-004': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-004.e9392f8e46ba.mglb',
			bytes: 11524,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-004.4b66304a0fac.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-005': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-005.137753128b22.mglb',
			bytes: 6556,
			tri: 128,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-005.811c1d826310.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-006': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-006.15de3513a31f.mglb',
			bytes: 13636,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-006.ca63850c3707.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-007': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-007.701412ac5ae7.mglb',
			bytes: 13588,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-007.5fb4e79074c1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-008': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-008.c609c54191fa.mglb',
			bytes: 12868,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-008.4c0ac2559bbe.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-009': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-009.0b00aa45c94f.mglb',
			bytes: 12868,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-009.27be1bf671fc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-010': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-010.bdce5c4f0a65.mglb',
			bytes: 12868,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-010.edd1cce1fe41.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-011': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-011.edd438944f97.mglb',
			bytes: 12868,
			tri: 330,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-011.07b7d112ab98.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-012': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-012.ca5a4b1a6294.mglb',
			bytes: 6172,
			tri: 128,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-012.9e1c58641cad.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-013': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-013.fde4eb587839.mglb',
			bytes: 11608,
			tri: 288,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-013.64b9f2335b07.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-014': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-014.5f1197a59069.mglb',
			bytes: 11608,
			tri: 288,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-014.1af8fffa59e3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-mustache-015': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-mustache-015.1716bb204dca.mglb',
			bytes: 10068,
			tri: 224,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-mustache-015.f2cdd3ae0c0c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-pacifier-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-pacifier-001.6b5c85573d08.mglb',
			bytes: 12576,
			tri: 329,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-pacifier-001.d8fbff6c062d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-accessory-piercing-001': {
			family: 'ithappy',
			slot: 'accessory',
			file: 'parca-ithp-accessory-piercing-001.55fddc9a1e13.mglb',
			bytes: 4636,
			tri: 80,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-accessory-piercing-001.e3d52a8a4735.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-costume-8-002': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-costume-8-002.98f54929c167.mglb',
			bytes: 52524,
			tri: 1246,
			hides: ['hips', 'thighs', 'shins', 'feet'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-costume-8-002.9cc1957ee0bf.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-001': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-001.54d417615d1e.mglb',
			bytes: 23688,
			tri: 700,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-001.813c312cad72.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-002': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-002.43bc52622181.mglb',
			bytes: 26036,
			tri: 788,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-002.fd144cc61f36.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-003': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-003.1d6007516c3c.mglb',
			bytes: 31488,
			tri: 832,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-003.9339bf45b2f5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-004': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-004.b7d68f671c0c.mglb',
			bytes: 29732,
			tri: 876,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-004.6c03f8e8d04d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-005': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-005.d1f796dc7a9f.mglb',
			bytes: 52848,
			tri: 1352,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-005.b14ddc70fadb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-006': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-006.905a9ff17184.mglb',
			bytes: 23732,
			tri: 700,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-006.1b649592aa06.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-007': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-007.a3c6b7e8ca6e.mglb',
			bytes: 26036,
			tri: 788,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-007.2ea9d92b9562.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-008': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-008.ea527e777868.mglb',
			bytes: 31488,
			tri: 832,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-008.a27e4ebe6130.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-009': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-009.01f653a31804.mglb',
			bytes: 29732,
			tri: 876,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-009.1739891e7a3e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-010': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-010.f470311aead0.mglb',
			bytes: 48960,
			tri: 1352,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-010.8f58ba70dd47.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-011': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-011.ffdf3ce3d9c2.mglb',
			bytes: 45828,
			tri: 1400,
			hides: ['hips'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-011.4f7ca3f4d6c0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-012': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-012.549da27c4484.mglb',
			bytes: 48792,
			tri: 1140,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-012.9fe6ef33c8f2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-013': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-013.113d1372d026.mglb',
			bytes: 43608,
			tri: 788,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-013.6dd3cb00fc61.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-pants-014': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-pants-014.1ae89e1f7bea.mglb',
			bytes: 49552,
			tri: 1266,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-pants-014.00a155338999.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-001': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-001.44de0d3b43e0.mglb',
			bytes: 35544,
			tri: 700,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-001.118263060c98.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-002': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-002.c3e76663813f.mglb',
			bytes: 16068,
			tri: 392,
			hides: ['hips'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-002.8ecced324ab3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-003': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-003.c090656d09a0.mglb',
			bytes: 11504,
			tri: 304,
			hides: ['hips'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-003.227d4eef9a87.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-004': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-004.02d9170fbffc.mglb',
			bytes: 35544,
			tri: 700,
			hides: ['hips', 'thighs'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-004.c290cb271446.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-005': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-005.0557eaf8ae8c.mglb',
			bytes: 14148,
			tri: 392,
			hides: ['hips'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-005.873fdd65dd3b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-bottom-shorts-006': {
			family: 'ithappy',
			slot: 'bottom',
			file: 'parca-ithp-bottom-shorts-006.bb0915683aaf.mglb',
			bytes: 13044,
			tri: 304,
			hides: ['hips'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-bottom-shorts-006.6db7dd466222.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-1-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-1-001.209e22194cdd.mglb',
			bytes: 86768,
			tri: 2636,
			hides: ['upper_arms', 'hips', 'thighs', 'shins', 'feet'],
			excludes: ['top', 'bottom', 'shoes'],
			personal: true,
			preview: 'onizleme-ithp-costume-1-001.4adc8d8d5530.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-13-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-13-001.49e7632539b2.mglb',
			bytes: 84736,
			tri: 2466,
			hides: ['upper_arms', 'hips', 'thighs', 'shins', 'feet'],
			excludes: ['top', 'bottom', 'shoes'],
			personal: true,
			preview: 'onizleme-ithp-costume-13-001.8adc74fe7fb5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-14-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-14-001.b89bf120d30f.mglb',
			bytes: 97856,
			tri: 1879,
			hides: ['upper_arms', 'hips', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-14-001.f41b99709d9b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-2-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-2-001.f0b39a037d08.mglb',
			bytes: 91192,
			tri: 2716,
			hides: ['upper_arms', 'hips', 'thighs', 'shins'],
			excludes: ['top', 'bottom'],
			personal: false,
			preview: 'onizleme-ithp-costume-2-001.1fb0077d869b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-3-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-3-001.df9a1c2ee1ef.mglb',
			bytes: 93276,
			tri: 2716,
			hides: ['upper_arms', 'hips', 'thighs', 'shins'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-3-001.bf59fb8186b2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-4-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-4-001.5601b4208d28.mglb',
			bytes: 97060,
			tri: 2058,
			hides: ['upper_arms', 'hips', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-4-001.654e19fad993.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-5-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-5-001.a3f147785cf6.mglb',
			bytes: 98112,
			tri: 2566,
			hides: ['hips', 'thighs', 'shins', 'feet'],
			excludes: ['top', 'bottom', 'shoes'],
			personal: true,
			preview: 'onizleme-ithp-costume-5-001.ef9be9b71d0d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-7-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-7-001.a0f76090dd1e.mglb',
			bytes: 74800,
			tri: 2104,
			hides: ['upper_arms', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-7-001.0ac5322f9a2c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-9-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-9-001.5282151f34c9.mglb',
			bytes: 95952,
			tri: 2206,
			hides: ['torso', 'upper_arms', 'hips', 'thighs', 'shins', 'feet'],
			excludes: ['top', 'bottom', 'shoes'],
			personal: true,
			preview: 'onizleme-ithp-costume-9-001.8bb6180227bc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-001.42574656dfe9.mglb',
			bytes: 84012,
			tri: 2272,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.1788,
			preview: 'onizleme-ithp-costume-mascot-001.58a1cb2d9f68.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-002': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-002.8d342c56b1f9.mglb',
			bytes: 81296,
			tri: 2356,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.2684,
			preview: 'onizleme-ithp-costume-mascot-002.026c2ae35ea7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-003': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-003.aca7509213cd.mglb',
			bytes: 54412,
			tri: 1508,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.3993,
			preview: 'onizleme-ithp-costume-mascot-003.f266aafea650.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-004': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-004.141040c5e5ee.mglb',
			bytes: 86972,
			tri: 2462,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.213,
			preview: 'onizleme-ithp-costume-mascot-004.5047c0deaaf3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-005': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-005.841b00f9e6df.mglb',
			bytes: 60388,
			tri: 1864,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.2019,
			preview: 'onizleme-ithp-costume-mascot-005.6f0a00dc058d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-006': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-006.95682e604169.mglb',
			bytes: 92388,
			tri: 2484,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.147,
			preview: 'onizleme-ithp-costume-mascot-006.76aa3e80184b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-007': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-007.1f74c6703f6a.mglb',
			bytes: 79356,
			tri: 2048,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.1314,
			preview: 'onizleme-ithp-costume-mascot-007.a33811aebc43.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-mascot-008': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-mascot-008.9e31f993b2cf.mglb',
			bytes: 46044,
			tri: 1402,
			hides: [],
			excludes: ['hair', 'top', 'bottom', 'hat', 'glasses'],
			personal: false,
			head_top_add: 0.0291,
			preview: 'onizleme-ithp-costume-mascot-008.3159227ed9c6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-001': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-001.7f4e7b171cdf.mglb',
			bytes: 67908,
			tri: 1938,
			hides: ['hips', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-001.7bc9568792f1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-002': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-002.694345e06746.mglb',
			bytes: 97572,
			tri: 2294,
			hides: ['torso', 'hips', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-002.4cf496ebb592.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-003': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-003.7f480025c928.mglb',
			bytes: 90160,
			tri: 2318,
			hides: ['hips', 'thighs'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-003.f5a201516942.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-004': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-004.9298961c4cab.mglb',
			bytes: 57168,
			tri: 1604,
			hides: ['upper_arms', 'lower_arms'],
			excludes: ['top', 'bottom'],
			personal: false,
			preview: 'onizleme-ithp-costume-outfit-004.da37cb899904.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-005': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-005.f5b85e991bb2.mglb',
			bytes: 60496,
			tri: 1568,
			hides: [],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-005.fa1703852efb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-006': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-006.4eb8d80bcfb6.mglb',
			bytes: 45568,
			tri: 1280,
			hides: ['upper_arms'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-006.faeb83c03d03.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-007': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-007.556b69bb4d51.mglb',
			bytes: 36508,
			tri: 972,
			hides: [],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-007.a84d659f9789.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-008': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-008.7b1d91981f15.mglb',
			bytes: 24744,
			tri: 644,
			hides: [],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-008.afe4e62c375b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-009': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-009.3f0a60655b78.mglb',
			bytes: 27052,
			tri: 796,
			hides: [],
			excludes: ['top', 'bottom'],
			personal: false,
			preview: 'onizleme-ithp-costume-outfit-009.808d8d4b45bd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-costume-outfit-010': {
			family: 'ithappy',
			slot: 'costume',
			file: 'parca-ithp-costume-outfit-010.3ba11c0fb309.mglb',
			bytes: 60960,
			tri: 1795,
			hides: ['upper_arms'],
			excludes: ['top', 'bottom'],
			personal: true,
			preview: 'onizleme-ithp-costume-outfit-010.9b7bde579ddd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-anger-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-anger-001.bb5280454343.mglb',
			bytes: 23036,
			tri: 484,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-anger-001.d1270bc5ccee.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-anger-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-anger-002.d795cdd98169.mglb',
			bytes: 25016,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-anger-002.bb2099a921a2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-anger-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-anger-003.0ef1ccdd7d2e.mglb',
			bytes: 29176,
			tri: 498,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-anger-003.fbf583d4ab61.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-anger-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-anger-004.09fb808cb541.mglb',
			bytes: 26308,
			tri: 499,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-anger-004.1ee7d491328d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-angry-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-angry-001.c760e59d2e10.mglb',
			bytes: 24556,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-angry-001.c74f465a94dd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-angry-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-angry-002.3f7968065d70.mglb',
			bytes: 22948,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-angry-002.f3df1959e348.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-angry-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-angry-003.189abc903f68.mglb',
			bytes: 24004,
			tri: 452,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-angry-003.9b8a1ce813ed.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-angry-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-angry-004.d54570f15620.mglb',
			bytes: 26820,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-angry-004.941729ec94fa.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-compassion-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-compassion-003.b7623e90297d.mglb',
			bytes: 27692,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-compassion-003.7e1b1444592b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-compassion-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-compassion-004.51ebf912e032.mglb',
			bytes: 30668,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-compassion-004.816141674c38.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-confuse-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-confuse-001.f192886b469b.mglb',
			bytes: 23744,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-confuse-001.75b359b280f2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-confuse-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-confuse-002.6c354d8949c5.mglb',
			bytes: 25256,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-confuse-002.e999f0326411.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-confuse-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-confuse-003.d5ca3d49ab0c.mglb',
			bytes: 26968,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-confuse-003.a11ea71f7432.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-evil-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-evil-001.bbe8bd0f928f.mglb',
			bytes: 24552,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-evil-001.31f62f6cfafa.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-evil-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-evil-002.9ae326a3637a.mglb',
			bytes: 23092,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-evil-002.3212646c9ce7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-evil-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-evil-003.e9793a2e6f8b.mglb',
			bytes: 25300,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-evil-003.6e60efe83022.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-evil-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-evil-004.3a0d229fc940.mglb',
			bytes: 26116,
			tri: 499,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-evil-004.54349b65298e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-happy-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-happy-001.853288366054.mglb',
			bytes: 25512,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-happy-001.75fc236ded21.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-happy-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-happy-002.8816825fcbb6.mglb',
			bytes: 26472,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-happy-002.7b37ef1bdca4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-happy-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-happy-003.dd5a347cd84d.mglb',
			bytes: 25284,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-happy-003.9857bbd5aef5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-happy-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-happy-004.403544e8d1a3.mglb',
			bytes: 26120,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-happy-004.d029919c1458.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-impatience-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-impatience-001.83050cd1856a.mglb',
			bytes: 26440,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-impatience-001.25dd1bc27824.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-impatience-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-impatience-002.b55d7601b0f7.mglb',
			bytes: 25576,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-impatience-002.b446c1a9f621.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-madness-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-madness-003.636a8f598c1b.mglb',
			bytes: 27396,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-madness-003.b04456f7c268.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-neutral-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-neutral-001.d645cce291a8.mglb',
			bytes: 24828,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-neutral-001.e7fa7d51d45d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-neutral-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-neutral-002.8f43c7ac01c1.mglb',
			bytes: 23192,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-neutral-002.8535e86c5e30.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-neutral-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-neutral-003.efc08855b94f.mglb',
			bytes: 23504,
			tri: 432,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-neutral-003.8fd36a3c14a9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-neutral-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-neutral-004.5f20b97e7ddc.mglb',
			bytes: 27016,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-neutral-004.a6c814d5c7fd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-sad-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-sad-001.2b611854ed48.mglb',
			bytes: 24580,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-sad-001.c10685244b6c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-sad-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-sad-002.3645e4fcfb14.mglb',
			bytes: 22968,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-sad-002.a4ea48669e1b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-sad-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-sad-003.e68246b1d7ec.mglb',
			bytes: 23476,
			tri: 432,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-sad-003.218a7b4b1cc0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-sad-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-sad-004.27fdaa550154.mglb',
			bytes: 27056,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-sad-004.f7a8bca48e41.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-surprised-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-surprised-001.d3b4e4ca000f.mglb',
			bytes: 23584,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-surprised-001.ac98ddbe9422.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-surprised-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-surprised-002.d8c69063f229.mglb',
			bytes: 25020,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-surprised-002.5fd6979bfc78.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-surprised-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-surprised-003.91798ae7e89b.mglb',
			bytes: 28648,
			tri: 499,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-surprised-003.c7994ed50e7d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-surprised-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-surprised-004.995e113a0180.mglb',
			bytes: 30108,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-surprised-004.1ad2f35552a3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-usual-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-usual-001.afe1ce339586.mglb',
			bytes: 24536,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-usual-001.a88d75466e67.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-usual-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-usual-002.ce27de5f45d3.mglb',
			bytes: 23092,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-usual-002.af1ce2b233b5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-usual-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-usual-003.099c2728072e.mglb',
			bytes: 23480,
			tri: 432,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-usual-003.e17d44a2b8c0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-f-usual-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-f-usual-004.cc073cf9f48f.mglb',
			bytes: 26984,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-f-usual-004.2d95cb2028bf.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-anger-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-anger-001.9459f17bd1a7.mglb',
			bytes: 20104,
			tri: 411,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-anger-001.39d22420670f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-anger-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-anger-002.efed28324bb5.mglb',
			bytes: 24396,
			tri: 474,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-anger-002.4d002949ce79.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-anger-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-anger-003.6aca986b8e1b.mglb',
			bytes: 29572,
			tri: 499,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-anger-003.c00436710619.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-anger-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-anger-004.d6049aae21d9.mglb',
			bytes: 24264,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-anger-004.070810949861.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-angry-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-angry-001.30bd5d447b59.mglb',
			bytes: 22024,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-angry-001.c5f1ad606370.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-angry-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-angry-002.6e1a88013e42.mglb',
			bytes: 18620,
			tri: 406,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-angry-002.78cd35ce577a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-angry-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-angry-003.1799235fd321.mglb',
			bytes: 20032,
			tri: 350,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-angry-003.0f168d1b72ec.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-angry-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-angry-004.0f7cf2c5cd57.mglb',
			bytes: 21644,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-angry-004.02e36be6cae8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-compassion-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-compassion-003.b4993c9c289e.mglb',
			bytes: 27424,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-compassion-003.ab541cc1d986.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-compassion-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-compassion-004.7a39b605b2ba.mglb',
			bytes: 29008,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-compassion-004.1ca47d3c49d3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-confuse-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-confuse-001.2d782c26016f.mglb',
			bytes: 18968,
			tri: 416,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-confuse-001.5aad9f8e2f05.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-confuse-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-confuse-002.0ad013a9de38.mglb',
			bytes: 21684,
			tri: 416,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-confuse-002.9fd2deea5c75.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-confuse-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-confuse-004.8e4295aeb5c8.mglb',
			bytes: 21492,
			tri: 416,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-confuse-004.bdca1fc3506e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-evil-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-evil-001.2509d222585d.mglb',
			bytes: 22044,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-evil-001.54a953070074.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-evil-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-evil-002.f627bf981053.mglb',
			bytes: 18640,
			tri: 406,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-evil-002.0ca55bafd971.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-evil-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-evil-003.9a720ffe93a5.mglb',
			bytes: 25080,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-evil-003.d88a67afabbb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-evil-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-evil-004.9810490db810.mglb',
			bytes: 24244,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-evil-004.ba76ab730570.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-happy-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-happy-001.4b2558459663.mglb',
			bytes: 21224,
			tri: 370,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-happy-001.1fa1fedfd84e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-happy-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-happy-002.64dd309afc9b.mglb',
			bytes: 22120,
			tri: 390,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-happy-002.e1f6fab932f9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-happy-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-happy-003.f61ddda67736.mglb',
			bytes: 25064,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-happy-003.8b693d13f2ee.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-happy-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-happy-004.5345d389231d.mglb',
			bytes: 24148,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-happy-004.ec64469cec24.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-impatience-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-impatience-001.426295ef3f41.mglb',
			bytes: 21220,
			tri: 370,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-impatience-001.6d3941050e91.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-impatience-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-impatience-002.6c3df14f70ac.mglb',
			bytes: 22108,
			tri: 390,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-impatience-002.0a1385fdae21.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-madness-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-madness-003.cdba542b58ea.mglb',
			bytes: 24240,
			tri: 414,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-madness-003.3c3af0704ed2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-neutral-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-neutral-001.ad2d93f20e17.mglb',
			bytes: 20876,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-neutral-001.8465084930d7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-neutral-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-neutral-002.1414b8fb18b8.mglb',
			bytes: 18644,
			tri: 406,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-neutral-002.c8e837860814.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-neutral-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-neutral-003.f77ed111a62e.mglb',
			bytes: 18168,
			tri: 342,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-neutral-003.6741064c9653.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-neutral-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-neutral-004.21fe3a01c808.mglb',
			bytes: 19080,
			tri: 398,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-neutral-004.4fbdaee128ff.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-sad-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-sad-001.cb505b26be79.mglb',
			bytes: 18616,
			tri: 406,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-sad-001.e1258bff1ad7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-sad-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-sad-002.b148b356424d.mglb',
			bytes: 22020,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-sad-002.e0539481035e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-sad-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-sad-003.ef3f653e2700.mglb',
			bytes: 22096,
			tri: 410,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-sad-003.e351e4b4de03.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-sad-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-sad-004.0a70a3d9f4a0.mglb',
			bytes: 21640,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-sad-004.c08235af0293.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-surprised-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-surprised-001.3ec5228f1978.mglb',
			bytes: 24200,
			tri: 472,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-surprised-001.22d75e01a921.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-surprised-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-surprised-002.f45318454e51.mglb',
			bytes: 22348,
			tri: 497,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-surprised-002.f429e03cc102.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-surprised-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-surprised-003.d2b0a1b2fd56.mglb',
			bytes: 28508,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-surprised-003.081400a89727.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-surprised-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-surprised-004.b3b0cf753ba6.mglb',
			bytes: 29488,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-surprised-004.ddf34a3fdf46.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-usual-001': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-usual-001.7c7abbebb4c5.mglb',
			bytes: 18636,
			tri: 406,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-usual-001.7b137687a8ee.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-usual-002': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-usual-002.ac84526c98df.mglb',
			bytes: 22048,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-usual-002.83e139b3e43d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-usual-003': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-usual-003.5c645d698338.mglb',
			bytes: 20036,
			tri: 350,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-usual-003.353f423a5f9e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-face-m-usual-004': {
			family: 'ithappy',
			slot: 'face',
			file: 'parca-ithp-face-m-usual-004.cde41913d0d2.mglb',
			bytes: 21664,
			tri: 426,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-face-m-usual-004.845e029a195a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-002': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-002.84e4aa8a6aa1.mglb',
			bytes: 19464,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-002.2e3d53876cf4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-003': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-003.e8b0e06587f8.mglb',
			bytes: 6848,
			tri: 156,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-003.d84789dcc3e2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-004': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-004.3083cd2d3e8a.mglb',
			bytes: 19272,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-004.a2874ed0fdc1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-005': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-005.10fdde3d0711.mglb',
			bytes: 15380,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-005.23cb19a438ff.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-006': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-006.8cfeb2c79665.mglb',
			bytes: 15092,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-006.debf43fb45d7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-007': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-007.7e9bdd2c2900.mglb',
			bytes: 15476,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-007.ccfd01969462.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-008': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-008.2383cff97428.mglb',
			bytes: 9388,
			tri: 258,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-008.32820ede6dab.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-009': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-009.b9ea81243285.mglb',
			bytes: 15092,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-009.d56b9e60eedc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-010': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-010.3ce598c77c67.mglb',
			bytes: 15764,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-010.d05220e113b5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-011': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-011.358558834974.mglb',
			bytes: 15284,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-011.2185f53905a9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-012': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-012.6df06e612b68.mglb',
			bytes: 22148,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-012.a0e47b98d547.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-013': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-013.5c60164e0839.mglb',
			bytes: 22532,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-013.c90b8f5ba63d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-014': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-014.62589d882c76.mglb',
			bytes: 12064,
			tri: 320,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-014.fd5c8ab2fca6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-015': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-015.4cafe23e5d3f.mglb',
			bytes: 12500,
			tri: 360,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-015.e7747fc0c3ec.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-016': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-016.c81302bd37d7.mglb',
			bytes: 34128,
			tri: 412,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-016.de3359914004.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-017': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-017.3c6e5f8bfc49.mglb',
			bytes: 37944,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-017.d856fb3a4e01.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-018': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-018.83eec48a83b4.mglb',
			bytes: 28056,
			tri: 392,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-018.40d2056f7b68.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-019': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-019.5e76cbd38847.mglb',
			bytes: 23440,
			tri: 392,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-019.011de453d04b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-020': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-020.0f7a5134101b.mglb',
			bytes: 26616,
			tri: 440,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-020.da8b831b31bc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-glasses-021': {
			family: 'ithappy',
			slot: 'glasses',
			file: 'parca-ithp-glasses-021.8765f04c790c.mglb',
			bytes: 16892,
			tri: 260,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-glasses-021.8a7aaf5fba23.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-f-001': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-f-001.4306a81aa573.mglb',
			bytes: 26340,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-f-001-sapka.7539bb13b594.mglb',
			head_top_add: 0.0247,
			preview: 'onizleme-ithp-hair-f-001.76b39c1ffc8c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-f-002': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-f-002.7634000aebed.mglb',
			bytes: 26440,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-f-002-sapka.4f3ce8809b68.mglb',
			head_top_add: 0.0203,
			preview: 'onizleme-ithp-hair-f-002.1610f818bd11.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-f-003': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-f-003.2ad7ceef84b1.mglb',
			bytes: 26580,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-f-003-sapka.0374bdce61de.mglb',
			head_top_add: 0.0138,
			preview: 'onizleme-ithp-hair-f-003.40912ede923c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-f-004': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-f-004.387a2005ae03.mglb',
			bytes: 16284,
			tri: 476,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-f-004-sapka.083015cd2a52.mglb',
			head_top_add: 0.0109,
			preview: 'onizleme-ithp-hair-f-004.3e778bc91120.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-f-005': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-f-005.1e60d5a33bca.mglb',
			bytes: 26824,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-f-005-sapka.efa7dc8a25a0.mglb',
			head_top_add: 0.025,
			preview: 'onizleme-ithp-hair-f-005.f1d5656aff05.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-001': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-001.1ac89483e37e.mglb',
			bytes: 27212,
			tri: 825,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-001-sapka.b4b11045089d.mglb',
			head_top_add: 0.0647,
			preview: 'onizleme-ithp-hair-fs-001.87f6589e4eae.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-002': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-002.cabf0171e49f.mglb',
			bytes: 26440,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-002-sapka.770dc3aacd44.mglb',
			head_top_add: 0.0283,
			preview: 'onizleme-ithp-hair-fs-002.90350ec1866c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-003': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-003.f82e270218a5.mglb',
			bytes: 22416,
			tri: 633,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-003-sapka.5482dca65fd4.mglb',
			head_top_add: 0.1422,
			preview: 'onizleme-ithp-hair-fs-003.6e470517ffe1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-004': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-004.99cf7b75e1be.mglb',
			bytes: 27784,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-004-sapka.3a629933fa70.mglb',
			head_top_add: 0.0181,
			preview: 'onizleme-ithp-hair-fs-004.96282edcf035.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-005': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-005.a9e6add814da.mglb',
			bytes: 28508,
			tri: 825,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-005-sapka.761633783135.mglb',
			head_top_add: 0.0512,
			preview: 'onizleme-ithp-hair-fs-005.a3645dc7858a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-006': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-006.720ac2cfcac9.mglb',
			bytes: 27448,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-006-sapka.80301d45e77a.mglb',
			head_top_add: 0.0831,
			preview: 'onizleme-ithp-hair-fs-006.39029ce70a5c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-fs-007': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-fs-007.779064542730.mglb',
			bytes: 29896,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-fs-007-sapka.ae852127c624.mglb',
			head_top_add: 0.0525,
			preview: 'onizleme-ithp-hair-fs-007.acc7f9090a36.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-001': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-001.a741d939c62d.mglb',
			bytes: 27888,
			tri: 825,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-001-sapka.cb4af9fceeb9.mglb',
			head_top_add: 0.0246,
			preview: 'onizleme-ithp-hair-m-001.28b45c76cf22.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-002': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-002.dd9ce081d7c0.mglb',
			bytes: 10716,
			tri: 286,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-002-sapka.bfbd7bddb19a.mglb',
			head_top_add: 0.016,
			preview: 'onizleme-ithp-hair-m-002.d764d4902aa5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-003': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-003.c5e4b0798a6e.mglb',
			bytes: 20460,
			tri: 628,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-003-sapka.03341f377727.mglb',
			head_top_add: 0.0271,
			preview: 'onizleme-ithp-hair-m-003.3282458bd9d3.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-004': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-004.d6828fee8241.mglb',
			bytes: 27448,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-004-sapka.b8554feaa6b3.mglb',
			head_top_add: 0.0239,
			preview: 'onizleme-ithp-hair-m-004.44d01157c9ef.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-005': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-005.700f0f92b3cf.mglb',
			bytes: 26340,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-005-sapka.85d0bbab4542.mglb',
			head_top_add: 0.0224,
			preview: 'onizleme-ithp-hair-m-005.a7b88e205927.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-m-006': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-m-006.86b51dd1eb7c.mglb',
			bytes: 30996,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-m-006-sapka.a97d4162269d.mglb',
			head_top_add: 0.0118,
			preview: 'onizleme-ithp-hair-m-006.55dc2c6bf900.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-001': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-001.76c11ac49b1e.mglb',
			bytes: 20524,
			tri: 630,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-001-sapka.f83a796fcf41.mglb',
			head_top_add: 0.0148,
			preview: 'onizleme-ithp-hair-ms-001.45c82a5004b6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-002': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-002.8e22e020bcbb.mglb',
			bytes: 26344,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-002-sapka.f01afb8a1769.mglb',
			head_top_add: 0.0501,
			preview: 'onizleme-ithp-hair-ms-002.3bf414ddb894.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-003': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-003.82c0a52c0630.mglb',
			bytes: 28752,
			tri: 825,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-003-sapka.61920a6387fc.mglb',
			head_top_add: 0.0491,
			preview: 'onizleme-ithp-hair-ms-003.ce6291142031.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-004': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-004.8879a4da32b1.mglb',
			bytes: 6000,
			tri: 124,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-004-sapka.ee28c4fdb549.mglb',
			head_top_add: 0.0584,
			preview: 'onizleme-ithp-hair-ms-004.22ab662de49f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-005': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-005.5a4853fc823c.mglb',
			bytes: 29992,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-005-sapka.4628ba5168bb.mglb',
			head_top_add: 0.0345,
			preview: 'onizleme-ithp-hair-ms-005.6c448f675f93.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-006': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-006.9c9d227b604a.mglb',
			bytes: 30000,
			tri: 825,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-006-sapka.c6c30f448a81.mglb',
			head_top_add: 0.0706,
			preview: 'onizleme-ithp-hair-ms-006.aaa9093b9a74.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-007': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-007.c0f3d476b176.mglb',
			bytes: 27160,
			tri: 824,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-007-sapka.bcf46f01a6b8.mglb',
			head_top_add: 0.0169,
			preview: 'onizleme-ithp-hair-ms-007.c8098671abfb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hair-ms-008': {
			family: 'ithappy',
			slot: 'hair',
			file: 'parca-ithp-hair-ms-008.9720b4a6405a.mglb',
			bytes: 12992,
			tri: 368,
			hides: [],
			excludes: [],
			personal: false,
			under_hat: 'parca-ithp-hair-ms-008-sapka.7688091d3067.mglb',
			head_top_add: 0.0642,
			preview: 'onizleme-ithp-hair-ms-008.75bb339ba27d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-001': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-001.ae5c055cff60.mglb',
			bytes: 20708,
			tri: 604,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.057,
			preview: 'onizleme-ithp-hat-001.e47d9887a87d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-002.3947bf26a5fe.mglb',
			bytes: 12816,
			tri: 336,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0569,
			preview: 'onizleme-ithp-hat-002.b0871d9049d1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-003': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-003.e1c62e7d779a.mglb',
			bytes: 13244,
			tri: 336,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0372,
			preview: 'onizleme-ithp-hat-003.841c2e373efb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-004': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-004.ceabbf13e1a3.mglb',
			bytes: 24600,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0816,
			preview: 'onizleme-ithp-hat-004.dbac307aa182.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-005': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-005.8d50978c2957.mglb',
			bytes: 11084,
			tri: 304,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0606,
			preview: 'onizleme-ithp-hat-005.2e347e795d1c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-006': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-006.f46db367e4cc.mglb',
			bytes: 17268,
			tri: 510,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0424,
			preview: 'onizleme-ithp-hat-006.e15700de2149.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-007': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-007.538c986a7a9b.mglb',
			bytes: 8260,
			tri: 210,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0427,
			preview: 'onizleme-ithp-hat-007.92a8da435eed.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-008': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-008.1ba5f7f36732.mglb',
			bytes: 12936,
			tri: 364,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0362,
			preview: 'onizleme-ithp-hat-008.9a46ef042f70.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-009': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-009.814390aa2521.mglb',
			bytes: 11708,
			tri: 336,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0419,
			preview: 'onizleme-ithp-hat-009.c8ef9a706855.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-010': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-010.52ee6189eef4.mglb',
			bytes: 22364,
			tri: 640,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.07,
			preview: 'onizleme-ithp-hat-010.01a6f5a898ee.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-011': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-011.97707b483efd.mglb',
			bytes: 25704,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0403,
			preview: 'onizleme-ithp-hat-011.fed272caf178.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-012': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-012.4a4f46f92a77.mglb',
			bytes: 22492,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1733,
			preview: 'onizleme-ithp-hat-012.962482706d50.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-013': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-013.99fc66fc7b07.mglb',
			bytes: 26180,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1475,
			preview: 'onizleme-ithp-hat-013.38bf540e341e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-014': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-014.73b7f8c07cda.mglb',
			bytes: 23196,
			tri: 602,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.4013,
			preview: 'onizleme-ithp-hat-014.24c1677d27e6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-015': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-015.16529b2f45f7.mglb',
			bytes: 22584,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0946,
			preview: 'onizleme-ithp-hat-015.f2d23822feb7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-016': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-016.9cb7fe6c13d1.mglb',
			bytes: 22796,
			tri: 576,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.21,
			preview: 'onizleme-ithp-hat-016.7f5813871342.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-017': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-017.c9308b4d0738.mglb',
			bytes: 29300,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2851,
			preview: 'onizleme-ithp-hat-017.4de9b960ffb5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-018': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-018.65d7b8f3e38a.mglb',
			bytes: 19272,
			tri: 500,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1498,
			preview: 'onizleme-ithp-hat-018.083c788ca18d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-019': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-019.d9d1d56aafc8.mglb',
			bytes: 25032,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2615,
			preview: 'onizleme-ithp-hat-019.e2eeb8cb6f86.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-020': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-020.55d4a72f908a.mglb',
			bytes: 21432,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2382,
			preview: 'onizleme-ithp-hat-020.2987c6862b2a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-021': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-021.e75e27a6e4e6.mglb',
			bytes: 34108,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1591,
			preview: 'onizleme-ithp-hat-021.2beaf3467f5a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-022': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-022.223ddb667634.mglb',
			bytes: 14976,
			tri: 376,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0667,
			preview: 'onizleme-ithp-hat-022.f51c77fe768b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-023': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-023.409d65a4e82f.mglb',
			bytes: 21428,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1209,
			preview: 'onizleme-ithp-hat-023.92df861b1614.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-024': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-024.b24f28665287.mglb',
			bytes: 21912,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0594,
			preview: 'onizleme-ithp-hat-024.fe96f6b1e6ac.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-025': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-025.1ec0a4bb124c.mglb',
			bytes: 43756,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0319,
			preview: 'onizleme-ithp-hat-025.1b85812a3404.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-026': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-026.1aa2840287d7.mglb',
			bytes: 20268,
			tri: 434,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0522,
			preview: 'onizleme-ithp-hat-026.128f09239d1f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-027': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-027.c7752de3e7b6.mglb',
			bytes: 35212,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0903,
			preview: 'onizleme-ithp-hat-027.8d93acec5cc7.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-028': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-028.48fea1bde9c2.mglb',
			bytes: 27820,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1301,
			preview: 'onizleme-ithp-hat-028.f6644c337016.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-029': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-029.975b1c4c6ba9.mglb',
			bytes: 25080,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.4385,
			preview: 'onizleme-ithp-hat-029.6fb7d2edb81d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-030': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-030.277e702de06a.mglb',
			bytes: 19280,
			tri: 534,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1274,
			preview: 'onizleme-ithp-hat-030.d8ee6c6af890.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-032': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-032.3d749e469188.mglb',
			bytes: 28780,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2948,
			preview: 'onizleme-ithp-hat-032.de4947c46181.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-033': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-033.1e2eec5523f4.mglb',
			bytes: 29980,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0374,
			preview: 'onizleme-ithp-hat-033.4e9cedadc6fd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-034': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-034.a47adea84442.mglb',
			bytes: 28084,
			tri: 648,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1178,
			preview: 'onizleme-ithp-hat-034.0ffb04c53173.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-035': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-035.3f86be2cdea8.mglb',
			bytes: 29980,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0822,
			preview: 'onizleme-ithp-hat-035.482f8b4d0348.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-036': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-036.bf2b4cc0cca2.mglb',
			bytes: 10160,
			tri: 246,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0988,
			preview: 'onizleme-ithp-hat-036.798d7da084ad.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-037': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-037.ac517a96d961.mglb',
			bytes: 13924,
			tri: 297,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0892,
			preview: 'onizleme-ithp-hat-037.ac09aa50c2af.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-038': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-038.c86698576fc1.mglb',
			bytes: 26904,
			tri: 580,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1579,
			preview: 'onizleme-ithp-hat-038.d60810d5e797.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-039': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-039.469296ff6550.mglb',
			bytes: 17400,
			tri: 484,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.4295,
			preview: 'onizleme-ithp-hat-039.30e1e8bad0c1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-040': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-040.b675a7c9180d.mglb',
			bytes: 15860,
			tri: 411,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0707,
			preview: 'onizleme-ithp-hat-040.9e3381eb7cd1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-041': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-041.72aca1bf0254.mglb',
			bytes: 25416,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1321,
			preview: 'onizleme-ithp-hat-041.06d7942d6654.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-042': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-042.39c986058e45.mglb',
			bytes: 27864,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2552,
			preview: 'onizleme-ithp-hat-042.034248dbfaed.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-043': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-043.f1d41fe1b525.mglb',
			bytes: 30072,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0322,
			preview: 'onizleme-ithp-hat-043.f784b980acae.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-044': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-044.fe300e860e7e.mglb',
			bytes: 38568,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2766,
			preview: 'onizleme-ithp-hat-044.bfda52247f38.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-045': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-045.7256c0b565da.mglb',
			bytes: 34392,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1798,
			preview: 'onizleme-ithp-hat-045.f469a7e6d723.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-046': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-046.553cf23300cc.mglb',
			bytes: 24192,
			tri: 544,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0803,
			preview: 'onizleme-ithp-hat-046.f9055ad81835.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-047': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-047.b7e52eb6e67e.mglb',
			bytes: 32232,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1568,
			preview: 'onizleme-ithp-hat-047.76232839207a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-048': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-048.04c690febbc6.mglb',
			bytes: 24888,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0389,
			preview: 'onizleme-ithp-hat-048.04359576afc4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-13-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-13-002.60cc61dc2568.mglb',
			bytes: 32256,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1568,
			preview: 'onizleme-ithp-hat-costume-13-002.76232839207a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-14-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-14-002.24228fd8a249.mglb',
			bytes: 36288,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1668,
			preview: 'onizleme-ithp-hat-costume-14-002.7af1e229d8e8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-3-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-3-002.7c3dedfd52a2.mglb',
			bytes: 32344,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0795,
			preview: 'onizleme-ithp-hat-costume-3-002.593750d678c9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-4-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-4-002.1c256a6a770a.mglb',
			bytes: 26036,
			tri: 656,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1593,
			preview: 'onizleme-ithp-hat-costume-4-002.5a2904508ca6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-5-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-5-002.c36e9e5b8f87.mglb',
			bytes: 20876,
			tri: 612,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1577,
			preview: 'onizleme-ithp-hat-costume-5-002.cb777f843220.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-costume-7-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-costume-7-002.c873feaebe45.mglb',
			bytes: 24332,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1669,
			preview: 'onizleme-ithp-hat-costume-7-002.f356e1d4eb82.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-001': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-001.674c38c3567b.mglb',
			bytes: 26772,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.163,
			preview: 'onizleme-ithp-hat-single-001.122edd634561.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-002': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-002.4324164b4a00.mglb',
			bytes: 34120,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.2048,
			preview: 'onizleme-ithp-hat-single-002.f14881cc39a6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-003': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-003.dc6412875967.mglb',
			bytes: 27348,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1042,
			preview: 'onizleme-ithp-hat-single-003.8cbe66d8d983.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-004': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-004.0b38e334a247.mglb',
			bytes: 29320,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0544,
			preview: 'onizleme-ithp-hat-single-004.be5eedf0e9ae.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-005': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-005.499d2aacf1fb.mglb',
			bytes: 27112,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1212,
			preview: 'onizleme-ithp-hat-single-005.27e1fec7427c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-006': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-006.89040e6fcdfb.mglb',
			bytes: 32624,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.3811,
			preview: 'onizleme-ithp-hat-single-006.8e4f561f4fe4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-007': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-007.ccf541a8d47f.mglb',
			bytes: 27156,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1013,
			preview: 'onizleme-ithp-hat-single-007.e1f81f085c19.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-008': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-008.c4f1d100715b.mglb',
			bytes: 26200,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0353,
			preview: 'onizleme-ithp-hat-single-008.bfc1a8e42685.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-009': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-009.6c5790fb861b.mglb',
			bytes: 21728,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1672,
			preview: 'onizleme-ithp-hat-single-009.98a2dee40896.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-010': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-010.924f8037a3c2.mglb',
			bytes: 30940,
			tri: 626,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0258,
			preview: 'onizleme-ithp-hat-single-010.a8a0cb5b2479.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-011': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-011.74b322217f38.mglb',
			bytes: 28792,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0371,
			preview: 'onizleme-ithp-hat-single-011.e1c2928c7c8a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-012': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-012.a91f82936359.mglb',
			bytes: 32440,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.1693,
			preview: 'onizleme-ithp-hat-single-012.f826001c5664.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-013': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-013.8bfc9e5fad16.mglb',
			bytes: 37144,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0332,
			preview: 'onizleme-ithp-hat-single-013.428c46c39de9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-014': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-014.b6e5b4bd0bd9.mglb',
			bytes: 43144,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0955,
			preview: 'onizleme-ithp-hat-single-014.a47a67842ac5.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-hat-single-015': {
			family: 'ithappy',
			slot: 'hat',
			file: 'parca-ithp-hat-single-015.de054a083f2f.mglb',
			bytes: 33204,
			tri: 659,
			hides: [],
			excludes: [],
			personal: false,
			hair: 'under_hat',
			head_top_add: 0.0608,
			preview: 'onizleme-ithp-hat-single-015.94f2e4fb6fe0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-001': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-001.5625b73f3539.mglb',
			bytes: 21512,
			tri: 452,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-001.69d5b03bab7e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-002': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-002.de355a6b7a77.mglb',
			bytes: 25160,
			tri: 612,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-002.bf7c985bca38.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-003': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-003.551f2fa4637e.mglb',
			bytes: 30872,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-003.ccbd5ab7203b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-004': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-004.4dcbab5622d3.mglb',
			bytes: 29964,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-004.5392c7d38f62.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-005': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-005.4825e9728fa5.mglb',
			bytes: 29964,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-005.88b143a84ccf.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-006': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-006.f7c395ef1a16.mglb',
			bytes: 27924,
			tri: 576,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-006.88285af0745a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-slippers-007': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-slippers-007.bb9758ef151f.mglb',
			bytes: 21324,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-slippers-007.714a5f578b90.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-001': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-001.48f449746187.mglb',
			bytes: 42444,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-001.263f04acfa18.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-002': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-002.9896fa2d578d.mglb',
			bytes: 22196,
			tri: 630,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-002.5c559940fa4b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-004': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-004.6a2d31173319.mglb',
			bytes: 25832,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-004.f9b28686da1b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-005': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-005.3d3c0a8643e7.mglb',
			bytes: 38412,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-005.998ac56f74fd.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-006': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-006.f0617995a8a8.mglb',
			bytes: 43980,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-006.a48d1c49c6f1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-007': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-007.354706c45be3.mglb',
			bytes: 28860,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-007.5034d9508c1f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-008': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-008.3212f2d5120f.mglb',
			bytes: 28860,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-008.62e3788aae69.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-009': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-009.ff25c3edab57.mglb',
			bytes: 36308,
			tri: 660,
			hides: ['feet'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-009.83ff61c1d5ed.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-010': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-010.8c5e145afe1a.mglb',
			bytes: 26076,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-010.255633cd6aab.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-011': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-011.612732e92774.mglb',
			bytes: 32268,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-011.f24b37dbb6b0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-012': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-012.9f831185c932.mglb',
			bytes: 33044,
			tri: 660,
			hides: ['feet'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-012.c15a192bd5bb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-013': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-013.26c57403ab10.mglb',
			bytes: 43980,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-013.e81c36258128.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-014': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-014.b8cbb70b9c11.mglb',
			bytes: 32268,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-014.1447d90fcb87.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-sneakers-015': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-sneakers-015.32259f9dbb79.mglb',
			bytes: 36876,
			tri: 660,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-sneakers-015.31d0e5196c80.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-001': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-001.ac868ae3b8df.mglb',
			bytes: 9272,
			tri: 238,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-001.7ada50722424.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-002': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-002.89122e0f1a92.mglb',
			bytes: 9272,
			tri: 238,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-002.8fa03a452a82.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-003': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-003.0a6285481c04.mglb',
			bytes: 9272,
			tri: 238,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-003.d75f0ec0d757.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-004': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-004.c8925240fcfb.mglb',
			bytes: 9272,
			tri: 238,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-004.4d42756c7422.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-005': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-005.8fdcb8ac2ca0.mglb',
			bytes: 9272,
			tri: 238,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-005.e6dc2c7aa74e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-006': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-006.78c930ccd56b.mglb',
			bytes: 26708,
			tri: 486,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-006.daf0c2b95fec.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-007': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-007.1ba970ae93aa.mglb',
			bytes: 17200,
			tri: 486,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-007.ef6ae40e8ebc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-shoes-socks-008': {
			family: 'ithappy',
			slot: 'shoes',
			file: 'parca-ithp-shoes-socks-008.c29b786e0bf7.mglb',
			bytes: 14556,
			tri: 398,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-shoes-socks-008.58bf0c586f6b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-costume-8-001': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-costume-8-001.7499086f7f10.mglb',
			bytes: 63032,
			tri: 1276,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-costume-8-001.e433bc8460be.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-001': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-001.0e6091b32c5d.mglb',
			bytes: 23712,
			tri: 700,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-001.07e96053d308.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-002': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-002.fab93e20f6f2.mglb',
			bytes: 20448,
			tri: 564,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-002.55884fd917e8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-003': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-003.50b6c6682a40.mglb',
			bytes: 45140,
			tri: 1296,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-003.99c195b9d780.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-004': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-004.53fe71e8dac5.mglb',
			bytes: 35208,
			tri: 960,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-004.00e1247f4db0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-005': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-005.0242a7f26e8c.mglb',
			bytes: 41748,
			tri: 1074,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-005.5818c070e2f9.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-006': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-006.66ad00d455fe.mglb',
			bytes: 45924,
			tri: 1130,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-006.a039f69e88ea.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-007': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-007.d981e650e8f4.mglb',
			bytes: 37056,
			tri: 988,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-007.7a34103e2b24.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-008': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-008.9215d47e5e30.mglb',
			bytes: 28204,
			tri: 754,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-008.ae1502229449.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-009': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-009.b1d5b2dd7262.mglb',
			bytes: 36208,
			tri: 942,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-009.0fa9ec968a94.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-010': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-010.70aa9fbaae9b.mglb',
			bytes: 50196,
			tri: 1260,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-010.396f76437e2d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-011': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-011.c0853a183ce4.mglb',
			bytes: 28796,
			tri: 700,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-011.7fdff44f4949.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-012': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-012.fd5d9fdcfe2b.mglb',
			bytes: 20448,
			tri: 564,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-012.d209cfe5c0b2.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-013': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-013.dd4a201e0aee.mglb',
			bytes: 45140,
			tri: 1296,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-013.d89f985a101f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-014': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-014.4598fb1f5ecd.mglb',
			bytes: 37412,
			tri: 960,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-014.6fe6493c867d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-015': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-015.99ff6c10633e.mglb',
			bytes: 41748,
			tri: 1074,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-015.2b4e1521d379.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-016': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-016.29c551a33def.mglb',
			bytes: 47460,
			tri: 1130,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-016.38f581f0a7dc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-017': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-017.e96726154977.mglb',
			bytes: 37056,
			tri: 988,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-017.ade417fa00f6.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-018': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-018.ad16ae6dc3a6.mglb',
			bytes: 28448,
			tri: 722,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-018.d89c5bdeeb2a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-019': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-019.55212f142f84.mglb',
			bytes: 37932,
			tri: 878,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-019.20d1e957021a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-020': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-020.c73d14af7e02.mglb',
			bytes: 50196,
			tri: 1260,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-020.514eb7aebf39.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-021': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-021.098fad425df6.mglb',
			bytes: 58280,
			tri: 1516,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-021.c25c543e62f4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-022': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-022.4edf3f357479.mglb',
			bytes: 67100,
			tri: 1800,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-022.260392d3750c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-023': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-023.d1857b4d53be.mglb',
			bytes: 41264,
			tri: 1236,
			hides: ['upper_arms'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-023.535acce18b05.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-024': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-024.0f6e419abaac.mglb',
			bytes: 47676,
			tri: 1290,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-024.fddc1758ffff.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-025': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-025.9a522c5fb089.mglb',
			bytes: 59408,
			tri: 1548,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-025.a7902a21179b.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-026': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-026.293311f032f4.mglb',
			bytes: 53152,
			tri: 1486,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-026.376899d16f20.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-027': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-027.33f6c304cc15.mglb',
			bytes: 63316,
			tri: 1800,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-027.110ab7c87ef8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-028': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-028.5ee5fbbc6356.mglb',
			bytes: 21008,
			tri: 609,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-028.5ca31d4e1713.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-029': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-029.ef96ab59755c.mglb',
			bytes: 47656,
			tri: 1338,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-029.d45b7f5f0dc1.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-030': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-030.ccbc260224cb.mglb',
			bytes: 32952,
			tri: 1008,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-030.1b709ad79c8e.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-031': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-031.6c931b9197be.mglb',
			bytes: 46268,
			tri: 1326,
			hides: ['upper_arms'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-031.568f46277216.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-032': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-032.5ce75bc8df53.mglb',
			bytes: 48180,
			tri: 1384,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-032.cbbf35c62dd8.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-033': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-033.c3d19d552368.mglb',
			bytes: 60500,
			tri: 1692,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-033.1fb37a22b3ab.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-034': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-034.d110a3e916c0.mglb',
			bytes: 22452,
			tri: 642,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-034.96a3cd23be62.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-035': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-035.571463f20f63.mglb',
			bytes: 57484,
			tri: 1558,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-035.2a92c3b399ae.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-036': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-036.7c15d87ea9e0.mglb',
			bytes: 16080,
			tri: 420,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-036.f32c64b690fb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-037': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-037.75f015ddd5c0.mglb',
			bytes: 68272,
			tri: 1708,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-037.e316873dbdd0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-038': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-038.385cec4c2d47.mglb',
			bytes: 73228,
			tri: 1799,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-038.62738f26570f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-039': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-039.c0f0217c7ac7.mglb',
			bytes: 73600,
			tri: 1799,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-039.7f92c942e1fb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-040': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-040.38a9e2aa47b7.mglb',
			bytes: 71200,
			tri: 1800,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-040.8861068fb73a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-041': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-041.bb0344e07105.mglb',
			bytes: 68520,
			tri: 1799,
			hides: ['lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-041.fbf6a17607db.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-042': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-042.c02d9023ed83.mglb',
			bytes: 70548,
			tri: 1800,
			hides: ['lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-042.b7d9ff1f8937.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-043': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-043.4ce583b65c77.mglb',
			bytes: 65756,
			tri: 1754,
			hides: ['lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-043.59b56798c1ec.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-044': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-044.dc3012758c05.mglb',
			bytes: 57204,
			tri: 1656,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-044.4bd0d39f8767.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-045': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-045.52920ec08ab2.mglb',
			bytes: 35832,
			tri: 1008,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-045.f50604731b6f.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-046': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-046.3184ed20939c.mglb',
			bytes: 63316,
			tri: 1800,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-046.393e72f4f6ad.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-047': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-047.502a674461f1.mglb',
			bytes: 43904,
			tri: 1236,
			hides: ['upper_arms'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-047.a090a17d61ca.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-048': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-048.1204a7819ff5.mglb',
			bytes: 57728,
			tri: 1548,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-048.8ebef570d77c.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-049': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-049.500d1374941d.mglb',
			bytes: 65372,
			tri: 1708,
			hides: ['upper_arms', 'lower_arms'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-049.ace22c9d8f21.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-050': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-050.4cc27c5ea677.mglb',
			bytes: 48140,
			tri: 1486,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-050.c4859e22f752.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-051': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-051.355f38a4d590.mglb',
			bytes: 53736,
			tri: 1420,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-051.0b948c876d76.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-052': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-052.b71f766d39a6.mglb',
			bytes: 43072,
			tri: 1090,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-052.323465a4900d.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-053': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-053.52725fb1fbbb.mglb',
			bytes: 39232,
			tri: 1006,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-053.7c459bc721a0.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-054': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-054.1ef3a4580543.mglb',
			bytes: 39864,
			tri: 984,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-054.6736b3a99ed4.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-055': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-055.4bc47e2ce585.mglb',
			bytes: 54524,
			tri: 1326,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-055.942c62edeb0a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-056': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-056.9fce4e22d697.mglb',
			bytes: 49924,
			tri: 1188,
			hides: [],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-056.8d5664c2fafb.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-057': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-057.d64f8d8b2b7f.mglb',
			bytes: 88884,
			tri: 1800,
			hides: ['upper_arms'],
			excludes: [],
			personal: false,
			preview: 'onizleme-ithp-top-outwear-057.26e4dc7c56dc.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-058': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-058.e4a9ce4df239.mglb',
			bytes: 79520,
			tri: 1799,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-058.c58f3d1ed924.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-059': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-059.3a6f88f2c71b.mglb',
			bytes: 89356,
			tri: 1799,
			hides: ['upper_arms'],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-059.bfe7b3a26d6a.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
		'ithp-top-outwear-060': {
			family: 'ithappy',
			slot: 'top',
			file: 'parca-ithp-top-outwear-060.e12938c6409e.mglb',
			bytes: 53496,
			tri: 1326,
			hides: [],
			excludes: [],
			personal: true,
			preview: 'onizleme-ithp-top-outwear-060.85d9196f3b57.png',
			license: 'ithappy One-Time Purchase License Agreement',
		},
	},
	presets: {
		'ithp-ceketli': {
			family: 'ithappy',
			parts: [
				'ithp-face-m-usual-001',
				'ithp-hair-m-002',
				'ithp-top-outwear-029',
				'ithp-bottom-pants-014',
				'ithp-shoes-sneakers-009',
			],
			shirt: 0x3256ba,
			preview: 'onizleme-ithp-ceketli.820b2de5b0d2.png',
		},
		'ithp-gozluk': {
			family: 'ithappy',
			parts: [
				'ithp-face-m-usual-001',
				'ithp-hair-m-003',
				'ithp-top-outwear-036',
				'ithp-bottom-pants-010',
				'ithp-shoes-sneakers-004',
				'ithp-glasses-004',
			],
			shirt: 0xdd367d,
			preview: 'onizleme-ithp-gozluk.fd6accb65114.png',
		},
		'ithp-gunluk': {
			family: 'ithappy',
			parts: [
				'ithp-face-m-usual-001',
				'ithp-hair-m-001',
				'ithp-top-outwear-001',
				'ithp-bottom-pants-010',
				'ithp-shoes-sneakers-009',
			],
			shirt: 0x3a979d,
			preview: 'onizleme-ithp-gunluk.8e681eb1305d.png',
		},
		'ithp-kulaklik': {
			family: 'ithappy',
			parts: [
				'ithp-face-f-usual-001',
				'ithp-hair-f-003',
				'ithp-top-outwear-029',
				'ithp-bottom-shorts-003',
				'ithp-shoes-sneakers-009',
				'ithp-accessory-headphones-002',
			],
			shirt: 0x3256ba,
			preview: 'onizleme-ithp-kulaklik.a48d871a23f4.png',
		},
		'ithp-rahat': {
			family: 'ithappy',
			parts: ['ithp-face-f-usual-001', 'ithp-hair-f-001', 'ithp-shoes-sneakers-009', 'ithp-costume-outfit-001'],
			shirt: 0x4a7cca,
			preview: 'onizleme-ithp-rahat.e09401ffaf7b.png',
		},
		'ithp-sapkali': {
			family: 'ithappy',
			parts: [
				'ithp-face-m-usual-002',
				'ithp-hair-m-005',
				'ithp-top-outwear-029',
				'ithp-bottom-pants-014',
				'ithp-shoes-sneakers-009',
				'ithp-hat-010',
			],
			shirt: 0x3256ba,
			preview: 'onizleme-ithp-sapkali.03ea6931914d.png',
		},
		'ithp-sehirli': {
			family: 'ithappy',
			parts: [
				'ithp-face-f-usual-002',
				'ithp-hair-f-002',
				'ithp-top-outwear-036',
				'ithp-bottom-pants-014',
				'ithp-shoes-sneakers-004',
			],
			shirt: 0xdd367d,
			preview: 'onizleme-ithp-sehirli.b685c4fba52a.png',
		},
		'ithp-yazlik': {
			family: 'ithappy',
			parts: [
				'ithp-face-m-happy-002',
				'ithp-hair-m-004',
				'ithp-top-outwear-001',
				'ithp-bottom-shorts-003',
				'ithp-shoes-slippers-002',
			],
			shirt: 0x3a979d,
			preview: 'onizleme-ithp-yazlik.eb5263b582c3.png',
		},
	},
};
